import { useUserPresenceStore } from "../../store/useUserPresenceStore";

const UserStatusCustomAvatar = ({
  userId,
  customStyle = {},
  isAlwaysTrue = false,
}) => {
  const status =
    useUserPresenceStore((state) => state.userStatuses?.[userId]) || "OFFLINE";

  const statusConfig = {
    ONLINE: { color: "#24832c", text: "Online", display: "block" },
    OFFLINE: { color: "#FF0000", text: "Offline", display: "none" },
  };

  const currentStatus =
    statusConfig?.[status?.toUpperCase()] || statusConfig.OFFLINE;

  if (isAlwaysTrue) {
    return (
      <div
        style={{
          ...customStyle,
          backgroundColor: statusConfig.ONLINE.color,
          display: statusConfig.ONLINE.display,
        }}
      />
    );
  }

  return (
    <div
      style={{
        ...customStyle,
        backgroundColor: currentStatus.color,
        display: currentStatus.display,
      }}
    />
  );
};

export { UserStatusCustomAvatar };
